import { IconButton } from "@material-ui/core";
import { AttributesMixin, define, type } from "@type-r/models";
import { useModel } from "@type-r/react";
import { FilterModel } from "./base-filter-model";

import AddIcon from '@material-ui/icons/Add';
import * as React from 'react';

export interface BooleanFilter extends AttributesMixin<typeof BooleanFilter>{}
@define
export class BooleanFilter extends FilterModel {
    static attributes = {
        ...FilterModel.attributes,
        value: type(Boolean).required
    };

    delete() {
        this.value = undefined;
    }

    asLabel() {
        return undefined;
    }
}
export const EnterBoolean = ({ onEnter }) => {
    const state = useModel(BooleanFilter);

    return <>
        <IconButton
            aria-label="Add"
            size="small"
            onClick={ () => {
                state.$.value.true();
                onEnter( state.clone() );
            } }
        >
            <AddIcon />
        </IconButton>
    </>;
}